// Implements: F-IDN-009, F-IDN-026
/**
 * The invitation page's one write: accept with a name and a password. On success the server has
 * already set the session cookie, so the session bootstrap is read again and the person is in.
 */

import { useMutation, useQueryClient } from "@tanstack/react-query";
import type { UseMutationResult } from "@tanstack/react-query";

import type { ApiError } from "../../../shared/api/ApiError";
import { SESSION_SCOPES_KEY } from "../../../shared/api/queryKeys";
import type { UserSummary } from "../../../types/api";
import type { InvitationAcceptRequest } from "../../../types/organization";
import { acceptInvitation } from "../api/organizationApi";

export function useAcceptInvitation(): UseMutationResult<UserSummary, ApiError, InvitationAcceptRequest> {
  const queryClient = useQueryClient();
  return useMutation<UserSummary, ApiError, InvitationAcceptRequest>({
    mutationFn: acceptInvitation,
    onSuccess: () => queryClient.invalidateQueries({ queryKey: SESSION_SCOPES_KEY }),
  });
}
